import { StorageService } from '@/services/storage-service/interface';

export const localStorageService: StorageService = {
  set(key, value) {
    localStorage.setItem(key, value);
  },

  get(key) {
    return localStorage.getItem(key) ?? undefined;
  },

  del(key) {
    localStorage.removeItem(key);
  },
};
